import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1bad18e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "browser-details" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "cell-content" }
const _hoisted_4 = { class: "example-pagination-block" }

import { Browser, BrowserInfoDetailKV, BrowserTypesOfSearch, BrowserFilter } from '@/store/modules/browser/types';
import { BrowserGetters, BrowserMutations, BrowserActions } from '@/store/modules/browser';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { computed, onMounted, ref, watchEffect } from 'vue';
import { ElMessage } from 'element-plus'

import { defineComponent } from 'vue';
import { BrowserAPI } from '@/api/browser';

const __default__ = defineComponent({
    name: "BrowserInfoList",
});


interface highlight {
    normal: string,
    light: string,
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute();
const store = useStore();
const pageSize = ref<number>(10)
const currentPage = ref<number>(1)
const sizeChange = async (val: number) => {
    const projId = projectId.value;
    const uid = targetId.value;
    const taskId = selectedTaskId.value
    const size = val
    const page = currentPage.value
    await store.dispatch(`browser/${BrowserActions.asyncGetBrowserDetailsByPage}`, { projId, uid, ...selectedBrowserType.value, taskId, pageSize: size, pageNum: page })

    pageSize.value = val
}

const projectId = computed(() => typeof (route.params.projId) === "string" ? route.params.projId : route.params.projId[0])
const targetId = computed(() => typeof (route.params.targetId) === "string" ? route.params.targetId : route.params.targetId[0]);

const browserDetailsList = computed(() => {
    const res = store.getters[`browser/${BrowserGetters.getBrowserDetails}`](selectedBrowserType.value, selectedTaskId.value)
    return res.slice((currentPage.value - 1) * pageSize.value, currentPage.value * pageSize.value);
});

const browserDetailsCount = computed(() => {
    return store.getters[`browser/${BrowserGetters.getDetailsCount}`](selectedBrowserType.value, selectedTaskId.value);
});

const isDetailsLoading = computed(() => {
    return store.getters[`browser/${BrowserGetters.getDetailsLoading}`]
});

const selectedBrowserType = computed(() => {
    return store.getters[`browser/${BrowserGetters.getSelectType}`]
});

// const isAllDetailsLoaded = computed(() => {
//     return store.getters[`browser/${BrowserGetters.getIsAllDetailsLoaded}`](selectedBrowserType.value, selectedTaskId.value);
// });

const isDefaultTypeLoading = computed(() => {
    return store.getters[`browser/${BrowserGetters.getIsDefaultTypeLoading}`]
});

const selectedTaskId = computed(() => {
    return store.getters[`browser/${BrowserGetters.getSelectedTaskId}`]
});

const getHostByUrl = (url: string): string => {
    let pattern = /https?:\/\/([^/]+)\//i
    let host = url.match(pattern)
    if (host !== null) {
        return host[1]
    }
    return ""
}

const handleGetHostInfo = async (target: string) => {
    let host = getHostByUrl(target)
    if (host === "") return
    const projId = projectId.value;
    let uid = targetId.value
    let taskId = ""
    let searchTaskId = "all"
    if (target !== "") {
        store.dispatch(`browser/${BrowserActions.asyncGetSearchTypeList}`, { projId, uid, target: host, taskId, searchTaskId })
    }
}

const handleCliskToCopy = (content: string) => {
    try {
        let oInput = document.createElement('input');
        oInput.value = content;
        document.body.appendChild(oInput);
        oInput.select();
        document.execCommand("Copy");
        oInput.style.display = 'none';
        ElMessage({
            message: '复制成功',
            type: 'success',
        })
    } catch (err) {
        console.log(err)
    }

}

const handleCurrentPageChange = async (val: number) => {
    const projId = projectId.value;
    const uid = targetId.value;
    const taskId = selectedTaskId.value
    const size = pageSize.value
    await store.dispatch(`browser/${BrowserActions.asyncGetBrowserDetailsByPage}`, { projId, uid, ...selectedBrowserType.value, taskId, pageSize: size, pageNum: val })
}

const asyncGetDetailList = async (projId: string, uid: string, taskId: String, isAppend: boolean) => {
    await store.dispatch(`browser/${BrowserActions.asyncGetBrowserDetailsByPage}`, { projId, uid, ...selectedBrowserType.value, taskId, pageSize: pageSize.value, pageNum: currentPage.value })
}

const getLabelList = (info: BrowserInfoDetailKV[]): string[] => {
    let labelList: string[] = [];
    for (let i = 0; i < info.length; i++) {
        if (info[i].Key !== "taskid") {
            labelList.push(info[i].Key)
        }
    }
    return labelList
}

const getDataList = (data: Browser[]): BrowserInfoDetailKV[] => {
    let details = data[0].infoDetails;
    let infoList: BrowserInfoDetailKV[] = [];
    let labelList = getLabelList(details);
    for (let i = 0; i < data.length; i++) {
        let info: BrowserInfoDetailKV = {} as BrowserInfoDetailKV;
        for (let j = 0; j < data[i].infoDetails.length; j++) {
            info = {
                ...info,
                [labelList[j]]: data[i].infoDetails[j].Value,
            }
        }
        infoList.push(info);
    }
    return infoList
}

watchEffect(async () => {
    if (selectedBrowserType.value.browserType != "" && isDetailsLoading.value == false && isDefaultTypeLoading.value == false && browserDetailsList.value[0] === undefined) {
        const projId = projectId.value;
        const uid = targetId.value
        const taskId = selectedTaskId.value
        await asyncGetDetailList(projId, uid, taskId, true)
    }
});


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      (_unref(browserDetailsList).length !== 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_unref(browserDetailsList)[0] !== undefined)
              ? (_openBlock(), _createBlock(_component_el_table, {
                  key: 0,
                  class: "browser-details-table",
                  data: getDataList(_unref(browserDetailsList)),
                  stripe: "",
                  "max-height": "80%"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getLabelList(_unref(browserDetailsList)[0].infoDetails), (item) => {
                      return (_openBlock(), _createBlock(_component_el_table_column, {
                        key: item,
                        prop: item,
                        label: item,
                        "show-overflow-tooltip": true
                      }, {
                        default: _withCtx((scope) => [
                          _createVNode(_component_el_popover, {
                            placement: "right",
                            width: 100,
                            trigger: "click"
                          }, {
                            reference: _withCtx(() => [
                              _createElementVNode("span", _hoisted_3, _toDisplayString(scope.row[item]), 1)
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_el_button_group, { type: "primary" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_button, {
                                    link: "",
                                    onClick: ($event: any) => (handleCliskToCopy(scope.row[item]))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("复制 ")
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]),
                                  (item === 'url')
                                    ? (_openBlock(), _createBlock(_component_el_button, {
                                        key: 0,
                                        link: "",
                                        onClick: ($event: any) => (handleGetHostInfo(scope.row[item]))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("查看域名搜索结果 ")
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["prop", "label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["data"]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createBlock(_component_el_empty, {
            key: 1,
            "image-size": 200
          }))
    ])), [
      [_directive_loading, _unref(isDetailsLoading)]
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_pagination, {
        "current-page": currentPage.value,
        "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((currentPage).value = $event)),
        background: true,
        layout: "prev, pager, next, jumper,sizes",
        "page-sizes": [10, 20, 50, 100, 200],
        "default-page-size": 10,
        total: _unref(browserDetailsCount),
        onSizeChange: sizeChange,
        onCurrentChange: handleCurrentPageChange
      }, null, 8, ["current-page", "total"])
    ])
  ], 64))
}
}

})